const { formatCurrency } = require('@smarttransit/common')

function penaltyTodayLabels (totals, currency) {
  if (!totals) {
    return []
  }
  const prefix = currency || ''
  const labels = []
  const agentNet = (Number(totals.penaltyNet) || 0) + (Number(totals.topupNet) || 0)
  if (agentNet < 0) {
    labels.push('Penalties today: ' + prefix + formatCurrency(agentNet) + ' (' + (Number(totals.count) || 0) + ')')
  }
  const credited = Number(totals.creditedNet) || 0
  const creditCount = Number(totals.creditCount) || 0
  if (creditCount > 0 && credited >= 0) {
    const sign = credited > 0 ? '+' : ''
    labels.push('Penalty credits today: ' + sign + prefix + formatCurrency(credited) + ' (' + creditCount + ')')
  }
  return labels
}

module.exports = {
  penaltyTodayLabels
}
